import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#215f69",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 17H5a1 1 0 0 1-1-1v-5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a1 1 0 0 1-1 1h-3M8 4h8v5H8zm0 11h8v4H8z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "7",
      cy: "12",
      r: "1",
      fill: "#215f69"
    }, null, -1)
  ]))]))
}
export default { render: render }